import {
  Component,
  computed,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { deserializeMessagesFilters, IMessagesFilters, toDeliveryStatusesFilter } from 'src/app/filters';
import { getMessageDeliveryStatusIcons, getMessageSenderLabel } from 'src/app/forms/messageForms';
import { IMessage } from 'src/app/models';
import { CommunicationUserType, FilterField, MessageStatus } from 'src/app/models/enums';
import { MessageChannel } from 'src/app/models/enums/messageChannel';
import { LiteralService, UtilsService } from 'src/app/services';
import { checkboxFieldSource } from 'src/app/shared/filter-panel/filterOptionSources';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { IMessagesState } from 'src/app/store/states';
import { images } from 'src/images';

@Component({
  selector: 'app-messages-table',
  templateUrl: './messages-table.component.html',
  styleUrl: './messages-table.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessagesTableComponent {
  readonly messages = input<IMessagesState>();
  readonly userType = input<CommunicationUserType>(CommunicationUserType.USERS);
  readonly selectedMessageId = input<number>();
  readonly selectMessage = output<any>();
  readonly selectMessageDetail = output<any>();
  readonly filterChange = output<Partial<IMessagesFilters>>();

  private readonly queryParamMap = toSignal(this.activatedRoute.queryParamMap, {
    initialValue: this.activatedRoute.snapshot.queryParamMap,
  });
  readonly filters = computed(() => deserializeMessagesFilters(this.queryParamMap()));

  readonly deliveryStatusFilterSource = checkboxFieldSource(this.literalService, FilterField.MESSAGE_DELIVERY_STATUS);
  readonly channelFilterSource = checkboxFieldSource(this.literalService, FilterField.MESSAGE_CHANNELS);

  public images = images;
  public CommunicationUserType = CommunicationUserType;
  public TooltipPosition = TooltipPosition;
  public MessageChannel = MessageChannel;
  readonly MessageStatus = MessageStatus;
  readonly deliveryStatusIcons = getMessageDeliveryStatusIcons();

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
  ) {}

  getSenderLabel(message: IMessage): string {
    return getMessageSenderLabel(message, this.literalService);
  }

  filterByDeliveryStatus(deliveryStatuses: MessageStatus[]) {
    this.filterChange.emit({ selectedDeliveryStatuses: toDeliveryStatusesFilter(deliveryStatuses) });
  }

  filterByChannels(channels: MessageChannel[]) {
    this.filterChange.emit({ selectedChannels: channels });
  }

  showMessageData(id: number) {
    this.selectMessage.emit(id);
  }

  openMessage(event: MouseEvent, id: number) {
    if (event.ctrlKey || event.metaKey || event.shiftKey) return;
    event.preventDefault();
    this.showMessageData(id);
  }

  showMessageDetail(id: number) {
    this.selectMessageDetail.emit(id);
  }
}
